export const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID || "G-8QXNXBPHV6";

export function trackPageView(path) {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;
  window.gtag("event", "page_view", {
    page_path: path,
    page_location: window.location.href,
    page_title: document.title,
  });
}

export function trackEvent(name, params = {}) {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;
  window.gtag("event", name, params);
}

// Google Ads conversion tracking (shares the existing gtag.js; GA4 untouched).
export const ADS_ID = "AW-18467372062";
export const ADS_QUOTE_LABEL = "prV8CK_rzaUdEJ749uVE";

// Fire a Google Ads conversion. MUST be called only after a confirmed success.
export function trackAdsConversion(label) {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;
  window.gtag("event", "conversion", { send_to: `${ADS_ID}/${label}` });
}
